<mat-form-field [formGroup]="formGroup" [matTooltip]="!canLock ? (lockedText | async) : ''">
  <mat-label>{{ titleText }}</mat-label>
  <mat-select multiple [formControlName]="documentInformationType" (openedChange)="onSelectionOpenChanged($event)">
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option | docInfoValueDisplayName: valueDisplayName }}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="hintText">{{ hintText }}</mat-hint>
</mat-form-field>
